<section class="report-matric-filters">
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(4,minmax(0,1fr))']">
        <kendo-gridlayout-item>
          <div class="kendo-formfield date-range-wrapper">
            <kendo-daterange #dateRangePicker>
              <kendo-label text="Received Date (Start)" class="mr-16">
                <kendo-dateinput #startDateRange #startDateInput="ngModel" name="startDateInput" calendarType="classic"
                  class="dateinput width100" placeholder="Start Date" [fillMode]="'outline'" kendoDateRangeStartInput
                  [(ngModel)]="range.startDate" (blur)="updateDateFilters()" (ngModelChange)="updateDateFilters()"
                  (keydown.enter)="appliedFilters()" (click)="focusDateInput(true)"></kendo-dateinput>
              </kendo-label>
              <kendo-label text="Received Date (End)">
                <kendo-dateinput #endDateRange #endDateInput="ngModel" name="endDateInput" calendarType="classic"
                  class="mr-0 dateinput width100" placeholder="End Date" [fillMode]="'outline'" kendoDateRangeEndInput
                  [(ngModel)]="range.endDate" (blur)="updateDateFilters()" (ngModelChange)="updateDateFilters()"
                  (keydown.enter)="appliedFilters()" (click)="focusDateInput(false)"></kendo-dateinput>
              </kendo-label>
              <kendo-daterange-popup #dateRangePickerPopup autoCorrectOn="blur"></kendo-daterange-popup>
            </kendo-daterange>
          </div>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
            <app-company-select-kendo
            label="Client (Company)"
            placeholder="Search Client (Company)"
            [selectedId]="filterByIdValue(filterTypes.Client)"
            (selectionChanged)="setFilters($event, filterTypes.Client)"
            (enteredPressed)="appliedFilters()"
            ></app-company-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
          <app-contact-multi-select-kendo
          placeholder="Select contact"
          label="Client (Contact)"
          [selectedId]="filterByIdValue(filterTypes.ClientContact)"
          (selectionChanged)="setFilters($event, filterTypes.ClientContact)"
          (enteredPressed)="appliedFilters()"
          >
          </app-contact-multi-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
          <app-state-multi-select-kendo
          placeholder="Select state"
          label="Loss State"
          [selectedId]="filterByIdValue(filterTypes.LossState)"
          (selectionChanged)="setFilters($event, filterTypes.LossState)"
          (enteredPressed)="appliedFilters()"
          >
          </app-state-multi-select-kendo>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item *ngIf="showCancelled">
          <app-cancelled-reason-multiselect-kendo
            placeholder="Select a reason"
            label="Cancellation reason"
            [selectedId]="filterByIdValue(filterTypes.CancelledReason)"
            (selectionChanged)="setFilters($event, filterTypes.CancelledReason)"
            (enteredPressed)="appliedFilters()"
            >
          </app-cancelled-reason-multiselect-kendo>
        </kendo-gridlayout-item>
    </kendo-gridlayout>

    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(4,minmax(0,1fr))']" *ngIf="showAllFilters">
        <kendo-gridlayout-item>
          <app-company-select-kendo
          label="Bill To (Company)"
          placeholder="Select bill to"
          [selectedId]="filterByIdValue(filterTypes.BillToCompany)"
          (selectionChanged)="setFilters($event, filterTypes.BillToCompany)"
          (enteredPressed)="appliedFilters()"
          ></app-company-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
          <app-user-multi-select-kendo
          label="Investigator"
          [userViewFilter]="userViewFilter"
          placeholder="Select investigator"
          [selectedId]="filterByIdValue(filterTypes.Investigator)"
          [investigationRole]="userRoleName.Investigator"
          [includeInactive]="true"
          (selectionChanged)="setFilters($event, filterTypes.Investigator)"
          (enteredPressed)="appliedFilters()"
          ></app-user-multi-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
          <app-user-multi-select-kendo
          label="Tech Reviewer"
          [userViewFilter]="userViewFilter"
          placeholder="Select reviewer"
          [selectedId]="filterByIdValue(filterTypes.TechReviewer)"
          [investigationRole]="userRoleName.TechReviewer"
          [includeInactive]="true"
          (selectionChanged)="setFilters($event, filterTypes.TechReviewer)"
          (enteredPressed)="appliedFilters()"
          ></app-user-multi-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
          <app-causes-multi-select-kendo
          placeholder="Select cause"
          label="Cause of Fire"
          [selectedId]="filterByIdValue(filterTypes.CauseOfFire)"
          (selectionChanged)="setFilters($event, filterTypes.CauseOfFire)"
          (enteredPressed)="appliedFilters()"
          >
          </app-causes-multi-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item>
          <app-risk-type-multi-select-kendo
          placeholder="Select type"
          label="Risk Type"
          [selectedId]="filterByIdValue(filterTypes.RiskType)"
          (selectionChanged)="setFilters($event, filterTypes.RiskType)"
          (enteredPressed)="appliedFilters()"
          >
          </app-risk-type-multi-select-kendo>
        </kendo-gridlayout-item>


        <kendo-gridlayout-item>
          <div class="kendo-formfield">
              <kendo-label [for]="InvestigationStatus" text="View By"></kendo-label>
              <kendo-dropdownlist
                #InvestigationStatus
                [data]="[{text: 'Active Investigations', value: 'ACTIVE'}, {text: 'Closed Investigations', value: 'CLOSED'}]"
                textField="text" valueField="value" fillMode="outline" [valuePrimitive]="true"
                [defaultItem]="{text: 'All Investigations', value: null }" [value]="filterValue(filterTypes.ViewBy)"
                [popupSettings]="{appendTo: 'component', animate: false, width: 250 }"
                (keydown.enter)="enterPress(InvestigationStatus)"
                (selectionChange)="setFilters($event?.value, filterTypes.ViewBy)">
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                  <span *ngIf="!dataItem?.value" class="placeholder"> {{ dataItem.text }} </span>
                  <span *ngIf="dataItem?.value" class="not-placeholder"> {{ dataItem.text }} </span>
                </ng-template>
              </kendo-dropdownlist>
          </div>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item *ngIf="showNefcoOfficeFilter">
          <app-nefco-office-multi-select
          [selectedId]="filterByIdValue(filterTypes.NefcoOffice)"
          (selectionChanged)="setFilters($event, filterTypes.NefcoOffice)"
          (enteredPressed)="appliedFilters()"
          >
          </app-nefco-office-multi-select>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item *ngIf="investigationFilter">
          <app-investigation-multi-select-kendo
            label="Investigation ID"
            placeholder="Search by nefco number"
            [selectedIds]="filterByIdValue(filterTypes.Ids)"
            (selectionChanged)="setVal($event, filterTypes.Ids)"
            (enteredPressed)="appliedFilters()"
          ></app-investigation-multi-select-kendo>
        </kendo-gridlayout-item>

        <kendo-gridlayout-item *ngIf="editorFilter">
          <app-user-multi-select-kendo
          label="Editor"
          [userViewFilter]="userViewFilter"
          placeholder="Select editor"
          [selectedId]="filterByIdValue(filterTypes.Editor)"
          [investigationRole]="userRoleName.Editor"
          [includeInactive]="true"
          (selectionChanged)="setFilters($event, filterTypes.Editor)"
          (enteredPressed)="appliedFilters()"
          ></app-user-multi-select-kendo>
        </kendo-gridlayout-item>

    </kendo-gridlayout>

    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 0}" [cols]="['repeat(2,minmax(0,1fr))']" style="margin-top: -16px;">
      <kendo-gridlayout-item>
        <div class="toggle-filters">
          <div>
            <kendo-button kendoButton themeColor="base" fillMode="solid" size="medium" iconClass="fa-solid fa-filter"
              (click)="showAllFilters = !showAllFilters">{{showAllFilters ? 'Hide Filters' : 'Show All Filters'}} </kendo-button>
              <button *ngIf="exportReport" kendoButton themeColor="light" fillMode="solid" iconClass="fa-solid fa-file-export" (click)="exportXlsx()"
              class="ml-24">Export as xlsx</button>
          </div>
          <div class="ml-16" *ngIf="cancelledFilter">
            <div class="d-flex align-items-center">
              <input type="checkbox" #Cancelled kendoCheckBox [checked]="filterValue(filterTypes.Cancelled)" name="cancelledCheckbox"
                (keydown.enter)="appliedFilters()" (change)="cancelledChange($event)" />
              <kendo-label class="k-checkbox-filter-label ml-12 mr-24" [for]="Cancelled" text="Cancelled"></kendo-label>
            </div>
          </div>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item class="filter-actions">
        <div class="mr-16 applied-filter">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="appliedFilters()">Apply
              Filters</kendo-button>
          </div>
        </div>
        <div class="mt-5 clear-filter">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearAll()">Clear
              All</kendo-button>
          </div>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
</section>
